import { CallMethodEnums } from '@/types/api';
import type {
  ActionLog, ModelLog, RequestLog, ResponseLog, SortOrder
} from '@/types/logs';

import { call } from './utils';

export type ActionLogResponse = {
  session_id: string;
  agent_actions: ActionLog[];
};

export type ModelLogResponse = {
  session_id: string;
  model_invocations: ModelLog[];
};

export type RequestLogResponse = {
  session_id: string;
  completion_requests: RequestLog[];
};

export type ResponseLogResponse = {
  completion_responses: ResponseLog[];
};

export const actionLogsGet = async(
  agent_id: string,
  batch_size: number,
  offset: number,
  request_id?: string,
  correlation_id?: string,
  session_id?: string
): Promise<ActionLogResponse> => {
  return call<unknown, ActionLogResponse>( {
    body: {
      agent_id,
      batch_size,
      offset,
      request_id: request_id || undefined,
      correlation_id: correlation_id || undefined,
      session_id: session_id || undefined,
      sort_order: 'DESC' satisfies SortOrder,
      sort_by: 'end_time'
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/logs/action_log'
  } );
};

export const requestLogsGet = async(
  agent_id: string,
  batch_size: number,
  offset: number,
  request_id?: string,
  correlation_id?: string,
  session_id?: string,
  start_time?: string,
  end_time?: string
): Promise<RequestLogResponse> => {
  return call<unknown, RequestLogResponse>( {
    body: {
      agent_id,
      batch_size,
      offset,
      request_id: request_id || undefined,
      correlation_id: correlation_id || undefined,
      session_id: session_id || undefined,
      start_time: start_time || undefined,
      end_time: end_time || undefined,
      sort_order: 'DESC' satisfies SortOrder,
      sort_by: 'start_time'
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/logs/completion_request_log'
  } );
};

export const responseLogsGet = async(
  call_id: string,
  max_results: number = 500
): Promise<ResponseLogResponse> => {
  return call<unknown, ResponseLogResponse>( {
    body: {
      call_id,
      max_results
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/logs/completion_response_log'
  } );
};

export const modelLogsGet = async(
  agent_id: string,
  batch_size: number,
  offset: number,
  request_id?: string,
  correlation_id?: string,
  session_id?: string
): Promise<ModelLogResponse> => {
  return call<unknown, ModelLogResponse>( {
    body: {
      agent_id,
      batch_size,
      offset,
      request_id: request_id || undefined,
      correlation_id: correlation_id || undefined,
      session_id: session_id || undefined,
      sort_order: 'DESC' satisfies SortOrder,
      sort_by: 'end_time'
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    route: '/api/logs/model_log_private'
  } );
};
